import { render, staticRenderFns } from "./PersonNumber.vue?vue&type=template&id=261520ae"
import script from "./PersonNumber.vue?vue&type=script&lang=js"
export * from "./PersonNumber.vue?vue&type=script&lang=js"
import style0 from "./PersonNumber.vue?vue&type=style&index=0&id=261520ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports